import axios from 'axios';
import getHeaders from '../../constants/headers';
import { BRAND_BASE_URL, STORE_BASE_URL } from '../BaseURL';


// export const uploadImage = (itemId, formData) => {
//   // const formData = new FormData();
//   // formData.append('fileData', logo); // Assuming 'file' is the file object you want to upload


//   return axios({
//     method: 'post',
//     url: STORE_BASE_URL + '/store/api/secure/v1/order-tag/' + itemId + '/image',
//     data: formData,
//     headers: getHeaders3(),
//   });
// };


export const getGarmentInspectionImages = orderId => {
  return axios({
    method: 'get',
    url: BRAND_BASE_URL + '/store/api/secure/v1/order-tag-images/' + orderId,
    headers: getHeaders(),
  });
};


export const getGarmentInspectionImagesSingleQrCode = orderQrCodeTagId => {
  return axios({
    method: 'get',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v1/order-tag/' +
      orderQrCodeTagId +
      '/image',
    headers: getHeaders(),
  });
};




export const deleteGarmentInspectionImage = (orderQrCodeTagId,imageId) => {
  return axios({
    method: 'delete',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v1/order-tag/' +
      orderQrCodeTagId +
      '/image/' + imageId,
    headers: getHeaders(),
  });
};


export const uploadLogo = (itemId,image) => {
    const formData = new FormData();
    formData.append("fileData", image); // Assuming 'file' is the file object you want to upload

    return axios({
        method: "post",
        url: STORE_BASE_URL + "/store/api/secure/v1/order-tag/" + itemId + "/image",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
  };
